// removed by extract-text-webpack-plugin
module.exports = {"monthlyReportPage":"-_P2E7-MQcDr4pU4pys61","monthlyReportTable":"_1nKem6SMRSHIEJ9aclXkVD"};


//////////////////
// WEBPACK FOOTER
// ./client/src/styles/MonthlyReportPage.scss
// module id = 588
// module chunks = 0